export const THEMES = {
  vhs: {
    id: 'vhs', label: 'VHS',
    '--bg': '#0C0C0A', '--bg-alt': '#111109', '--bg-card': '#181714', '--bg-elevated': '#1F1E1A', '--bg-tape': '#0E0D0A',
    '--accent': '#39FF6A', '--accent-dim': '#1A8038', '--accent-glow': 'rgba(57,255,106,0.12)',
    '--text': '#E8E5D0', '--text-dim': '#8A8778', '--text-muted': '#4A4940',
    '--border': '#222218', '--border-bright': 'rgba(57,255,106,0.2)',
  },
  midnight: {
    id: 'midnight', label: 'Midnight',
    '--bg': '#0A0B12', '--bg-alt': '#0D0F1A', '--bg-card': '#13162A', '--bg-elevated': '#1A1F3A', '--bg-tape': '#0C0E18',
    '--accent': '#818CF8', '--accent-dim': '#3730A3', '--accent-glow': 'rgba(129,140,248,0.12)',
    '--text': '#E2E8F0', '--text-dim': '#94A3B8', '--text-muted': '#475569',
    '--border': '#1E2240', '--border-bright': 'rgba(129,140,248,0.22)',
  },
  copper: {
    id: 'copper', label: 'Copper',
    '--bg': '#100C08', '--bg-alt': '#161008', '--bg-card': '#1C140C', '--bg-elevated': '#231A10', '--bg-tape': '#120E09',
    '--accent': '#E07B39', '--accent-dim': '#7C3D10', '--accent-glow': 'rgba(224,123,57,0.12)',
    '--text': '#F0E6D3', '--text-dim': '#9A8878', '--text-muted': '#5A4C40',
    '--border': '#2A1E14', '--border-bright': 'rgba(224,123,57,0.22)',
  },
  tape: {
    id: 'tape', label: 'Tape',
    '--bg': '#F5F0E8', '--bg-alt': '#EDE8DC', '--bg-card': '#E8E1D4', '--bg-elevated': '#DEDAD0', '--bg-tape': '#F0EBE2',
    '--accent': '#8B1A1A', '--accent-dim': '#5C1111', '--accent-glow': 'rgba(139,26,26,0.1)',
    '--text': '#1A1614', '--text-dim': '#5A4A40', '--text-muted': '#8A7A70',
    '--border': '#D4CEC4', '--border-bright': 'rgba(139,26,26,0.2)',
  },
  ghost: {
    id: 'ghost', label: 'Ghost',
    '--bg': '#FAFAFA', '--bg-alt': '#F4F4F4', '--bg-card': '#EDEDED', '--bg-elevated': '#E6E6E6', '--bg-tape': '#F8F8F8',
    '--accent': '#111111', '--accent-dim': '#444444', '--accent-glow': 'rgba(17,17,17,0.08)',
    '--text': '#0A0A0A', '--text-dim': '#444444', '--text-muted': '#888888',
    '--border': '#DDDDDD', '--border-bright': 'rgba(17,17,17,0.15)',
  },
};

const KEY = 'tapes_theme_v2';

export const getTheme = () => localStorage.getItem(KEY) || 'tape';

export function applyTheme(id) {
  const t = THEMES[id] || THEMES.vhs;
  const root = document.documentElement;
  Object.entries(t).forEach(([k, v]) => { if (k.startsWith('--')) root.style.setProperty(k, v); });
  localStorage.setItem(KEY, t.id);
}

export function initTheme() { applyTheme(getTheme()); }
